import EXTRA_LINES from "./catalogExtra.json"
const image = (id) => `/website-assets/images/${id}-1000x760.jpg`

export const PRODUCTS = [
  {
    id: "antivirus-biz",
    name: "Enterprise Antivirus & Endpoint Security",
    category: "Backup & Anti-Virus",
    condition: "new",
    description:
      "Business-grade endpoint protection with ransomware shielding and centralized management.",
    image: image("photo-1751448555253-f39c06e29d82"),
    items: [
      {
        id: "1-device",
        name: "1 Device / 1 Year",
        price: 49.99,
        detail: "Single business endpoint",
      },
      {
        id: "5-device",
        name: "5 Devices / 1 Year",
        price: 179,
        detail: "Small-team protection",
      },
      {
        id: "10-device",
        name: "10 Devices / 1 Year",
        price: 299,
        detail: "Centralized business security",
      },
    ],
  },
  {
    id: "cloud-backup",
    name: "Cloud Backup Solutions",
    category: "AI & Cloud Solutions",
    condition: "new",
    description:
      "Automated encrypted backup with instant restore and file versioning.",
    image: image("photo-1667984390538-3dea7a3fe33d"),
    items: [
      {
        id: "500gb",
        name: "500GB / 1 Year",
        price: 89,
        detail: "Workstation and file backup",
      },
      {
        id: "1tb",
        name: "1TB / 1 Year",
        price: 149,
        detail: "Expanded business storage",
      },
      {
        id: "2tb",
        name: "2TB / 1 Year",
        price: 249,
        detail: "Team and server backup",
      },
    ],
  },
  {
    id: "office-suite",
    name: "Business Productivity Software",
    category: "Software Supply",
    condition: "new",
    description:
      "Licensed documents, email, spreadsheets, meetings, and team collaboration.",
    image: image("photo-1678809768466-43d610e470b1"),
    items: [
      {
        id: "1-user",
        name: "1 User / 1 Year",
        price: 39,
        detail: "Individual productivity license",
      },
      {
        id: "5-user",
        name: "5 Users / 1 Year",
        price: 129,
        detail: "Small-team license pack",
      },
      {
        id: "10-user",
        name: "10 Users / 1 Year",
        price: 229,
        detail: "Growing business license pack",
      },
    ],
  },
  {
    id: "ai-assistant",
    name: "AI Workflow Assistants",
    category: "AI & Cloud Solutions",
    condition: "new",
    description:
      "AI automation for customer support, documents, internal knowledge, and reporting.",
    image: image("photo-1677442135131-4d7c123aef1c"),
    items: [
      {
        id: "starter",
        name: "Starter AI Assistant",
        price: 199,
        detail: "One workflow / annual plan",
      },
      {
        id: "business",
        name: "Business AI Assistant",
        price: 499,
        detail: "Up to five workflows",
      },
      {
        id: "custom",
        name: "Custom AI Deployment",
        price: 999,
        detail: "Integration and team setup",
      },
    ],
  },
  {
    id: "router-ent",
    name: "Enterprise Wi-Fi & Routing",
    category: "Networking",
    condition: "new",
    description:
      "Reliable wireless routing and access points for offices, hotels, and campuses.",
    image: image("photo-1544197150-b99a580bb7a8"),
    items: [
      {
        id: "dual-band",
        name: "Dual-Band Business Router",
        price: 159,
        detail: "Small office coverage",
      },
      {
        id: "wifi6-ap",
        name: "Wi-Fi 6 Access Point",
        price: 229,
        detail: "High-density wireless access",
      },
      {
        id: "gateway",
        name: "Managed Security Gateway",
        price: 399,
        detail: "Routing, VPN, and management",
      },
      {
        id: "u6-lr",
        brand: "Ubiquiti",
        name: "Ubiquiti UniFi U6-LR Long-Range Access Point",
        price: 261,
        detail: "4x4 MU-MIMO, 1.3 GHz dual-core, long-range coverage",
      },
      {
        id: "poe-48-24w",
        brand: "Ubiquiti",
        name: "Ubiquiti POE-48-24W-G Gigabit PoE Injector",
        price: 28,
        detail: "48VDC, 0.5A, 24W for Ubiquiti PoE devices",
      },
    ],
  },
  {
    id: "switch-24",
    name: "Managed Network Switches",
    category: "Networking",
    condition: "new",
    description:
      "Managed business switching with VLAN, QoS, fiber uplinks, and PoE options.",
    image: image("photo-1594915440248-1e419eba6611"),
    items: [
      {
        id: "8-port",
        name: "8-Port Managed Switch",
        price: 119,
        detail: "Compact office switching",
      },
      {
        id: "24-port",
        name: "24-Port Managed PoE Switch",
        price: 289,
        detail: "Business network deployment",
      },
      {
        id: "48-port",
        name: "48-Port Managed PoE Switch",
        price: 549,
        detail: "Enterprise access switching",
      },
      {
        id: "crs112-8p-4s",
        brand: "MikroTik",
        name: "MikroTik CRS112-8P-4S-IN 8-Port PoE Switch",
        price: 403,
        detail: "Gigabit PoE-out, 4x SFP cages, RouterOS",
      },
      {
        id: "mikrotik-48v-psu",
        brand: "MikroTik",
        name: "MikroTik 48V 2A 96W Power Supply",
        price: 82,
        detail: "100-240V AC in, 48V DC out, 2.1mm plug",
      },
    ],
  },
  {
    id: "cctv-kit",
    name: "CCTV Surveillance Systems",
    category: "Security & Cameras",
    condition: "new",
    description:
      "HD IP cameras, recording, night vision, and remote mobile monitoring.",
    image: image("photo-1589935447067-5531094415d1"),
    items: [
      {
        id: "2-camera",
        name: "2-Camera HD Kit",
        price: 229,
        detail: "Cameras, recorder, and storage",
      },
      {
        id: "4-camera",
        name: "4-Camera IP Kit",
        price: 349,
        detail: "Remote monitoring included",
      },
      {
        id: "8-camera",
        name: "8-Camera Business Kit",
        price: 699,
        detail: "Expanded site surveillance",
      },
    ],
  },
  {
    id: "laptop-biz",
    name: "Business Laptops",
    category: "Computers & Components",
    condition: "refurbished",
    description:
      "Certified business laptops with warranty and optional on-site setup.",
    image: image("photo-1611090093264-e107bcc465ad"),
    items: [
      {
        id: "i5-8-256",
        name: "Core i5 / 8GB / 256GB SSD",
        price: 549,
        detail: "Certified refurbished",
      },
      {
        id: "i7-16-512",
        name: "Core i7 / 16GB / 512GB SSD",
        price: 899,
        detail: "Certified refurbished",
      },
      {
        id: "i7-32-1tb",
        name: "Core i7 / 32GB / 1TB SSD",
        price: 1199,
        detail: "Performance workstation",
      },
    ],
  },
  {
    id: "ssd-1tb",
    name: "NVMe SSD Storage",
    category: "Computers & Components",
    condition: "new",
    description:
      "High-speed solid-state storage upgrades for laptops and desktops.",
    image: image("photo-1666868213704-1677b7f04c30"),
    items: [
      {
        id: "500gb",
        name: "500GB NVMe SSD",
        price: 59,
        detail: "Fast everyday storage",
      },
      {
        id: "1tb",
        name: "1TB NVMe SSD",
        price: 99,
        detail: "Performance storage upgrade",
      },
      {
        id: "2tb",
        name: "2TB NVMe SSD",
        price: 179,
        detail: "High-capacity performance",
      },
    ],
  },
  {
    id: "ram-16",
    name: "Computer Memory",
    category: "Computers & Components",
    condition: "new",
    description:
      "Tested performance memory for reliable, smoother multitasking.",
    image: image("photo-1541029071515-84cc54f84dc5"),
    items: [
      {
        id: "8gb",
        name: "8GB DDR4 RAM",
        price: 29,
        detail: "Laptop or desktop module",
      },
      {
        id: "16gb",
        name: "16GB DDR4 RAM",
        price: 45,
        detail: "Laptop or desktop module",
      },
      {
        id: "32gb",
        name: "32GB DDR4 RAM",
        price: 89,
        detail: "High-performance module",
      },
    ],
  },
  {
    id: "remote-support",
    name: "Remote IT Support",
    category: "Support Services",
    condition: "new",
    description:
      "Responsive remote technical assistance for individuals and business teams.",
    image: image("photo-1573166584647-2c1366f9b219"),
    items: [
      {
        id: "single",
        name: "Single Support Session",
        price: 39,
        detail: "Up to one hour",
      },
      {
        id: "monthly",
        name: "Monthly Support Plan",
        price: 79,
        detail: "Business-hours coverage",
      },
      {
        id: "priority",
        name: "Priority Monthly Plan",
        price: 199,
        detail: "Priority response for teams",
      },
    ],
  },
  {
    id: "datacenter-support",
    name: "Data Center Support",
    category: "Support Services",
    condition: "new",
    description:
      "Monitoring, preventive maintenance, and priority infrastructure response.",
    image: image("photo-1695668548342-c0c1ad479aee"),
    items: [
      {
        id: "assessment",
        name: "Infrastructure Assessment",
        price: 299,
        detail: "Health and risk review",
      },
      {
        id: "monthly",
        name: "Monthly Support Retainer",
        price: 499,
        detail: "Monitoring and maintenance",
      },
      {
        id: "priority",
        name: "Priority Support Retainer",
        price: 999,
        detail: "Enhanced incident response",
      },
    ],
  },
  {
    id: "custom-pc",
    name: "Custom Desktop Computers",
    category: "Computers & Components",
    condition: "new",
    description:
      "Purpose-built desktops for office, design, engineering, and performance workloads.",
    image: image("photo-1587831990711-23ca6441447b"),
    items: [
      {
        id: "office",
        name: "Office Desktop",
        price: 749,
        detail: "Core productivity configuration",
      },
      {
        id: "creative",
        name: "Creative Workstation",
        price: 1299,
        detail: "Design and media configuration",
      },
      {
        id: "engineering",
        name: "Engineering Workstation",
        price: 1899,
        detail: "High-performance configuration",
      },
    ],
  },
  {
    id: "monitor",
    name: "Professional Monitors",
    category: "Computers & Components",
    condition: "new",
    description:
      "Crisp displays for productivity, design, and multi-screen workstations.",
    image: image("photo-1548611716-3000815a5803"),
    items: [
      {
        id: "24-fhd",
        name: '24" Full HD Monitor',
        price: 159,
        detail: "Business productivity display",
      },
      {
        id: "27-qhd",
        name: '27" QHD Monitor',
        price: 219,
        detail: "Expanded professional workspace",
      },
      {
        id: "32-4k",
        name: '32" 4K Monitor',
        price: 449,
        detail: "High-resolution creative display",
      },
    ],
  },
  {
    id: "hdd",
    name: "External Backup Drives",
    category: "Computers & Components",
    condition: "new",
    description: "Portable USB storage for fast, dependable local backups.",
    image: image("photo-1703756291643-df456ffc8079"),
    items: [
      {
        id: "1tb",
        name: "1TB External Drive",
        price: 69,
        detail: "Portable USB 3.0 storage",
      },
      {
        id: "2tb",
        name: "2TB External Drive",
        price: 99,
        detail: "Expanded backup capacity",
      },
      {
        id: "4tb",
        name: "4TB External Drive",
        price: 159,
        detail: "Business backup storage",
      },
    ],
  },
  {
    id: "keyboard",
    name: "Keyboard & Mouse Sets",
    category: "Peripherals & Office",
    condition: "new",
    description:
      "Comfortable wired and wireless input sets for productive workspaces.",
    image: image("photo-1698934688661-522c99f4c98f"),
    items: [
      {
        id: "wired",
        name: "Wired Keyboard & Mouse",
        price: 25,
        detail: "Reliable office essentials",
      },
      {
        id: "wireless",
        name: "Wireless Keyboard & Mouse",
        price: 39,
        detail: "Clutter-free connectivity",
      },
      {
        id: "ergonomic",
        name: "Ergonomic Wireless Set",
        price: 79,
        detail: "Enhanced all-day comfort",
      },
    ],
  },
  {
    id: "printer",
    name: "Office Printers",
    category: "Peripherals & Office",
    condition: "new",
    description:
      "Dependable print, scan, and copy solutions for businesses of every size.",
    image: image("photo-1612815154858-60aa4c59eaa6"),
    items: [
      {
        id: "mono-laser",
        name: "Monochrome Laser Printer",
        price: 199,
        detail: "Fast everyday business printing",
      },
      {
        id: "multifunction",
        name: "Multifunction Office Printer",
        price: 299,
        detail: "Print, scan, and copy",
      },
      {
        id: "color-laser",
        name: "Color Laser Multifunction",
        price: 549,
        detail: "Professional color documents",
      },
    ],
  },
  {
    id: "scanner",
    name: "Document Scanners",
    category: "Peripherals & Office",
    condition: "new",
    description:
      "High-resolution document digitization for modern paperless workflows.",
    image: image("photo-1706895040634-62055892cbbb"),
    items: [
      {
        id: "portable",
        name: "Portable Document Scanner",
        price: 129,
        detail: "Mobile document capture",
      },
      {
        id: "desktop",
        name: "High-Speed Desktop Scanner",
        price: 189,
        detail: "Daily office digitization",
      },
      {
        id: "workgroup",
        name: "Workgroup Duplex Scanner",
        price: 399,
        detail: "High-volume team scanning",
      },
    ],
  },
  {
    id: "firewall",
    name: "Network Firewalls",
    category: "Security & Cameras",
    condition: "new",
    description:
      "Managed perimeter defense with secure VPN access and advanced threat filtering.",
    image: image("photo-1680992044138-ce4864c2b962"),
    items: [
      {
        id: "small-office",
        name: "Small Office Firewall",
        price: 249,
        detail: "Secure gateway and VPN",
      },
      {
        id: "business",
        name: "Business Security Appliance",
        price: 429,
        detail: "Managed threat protection",
      },
      {
        id: "enterprise",
        name: "Enterprise Firewall Appliance",
        price: 899,
        detail: "High-throughput security",
      },
    ],
  },
  {
    id: "access-control",
    name: "Access Control & Security Screening",
    category: "Security & Cameras",
    condition: "new",
    description:
      "Walk-through metal detectors and IP video intercoms for banks, offices, schools, and events.",
    image: image("lpo-metal-detector"),
    items: [
      {
        id: "zk-d2180",
        brand: "ZKTeco",
        name: "ZKTeco ZK-D2180 Walk-Through Metal Detector",
        price: 1434,
        detail: "18 zones, 500 sensitivity levels, 24/7 duty, CE/FCC",
      },
      {
        id: "ds-kis605",
        brand: "Hikvision",
        name: "Hikvision DS-KIS605-P(C) IP Video Intercom Kit",
        price: 234,
        detail: "Door station, indoor monitor, distributor & 5 key fobs",
      },
    ],
  },
  {
    id: "racks-power",
    name: "Racks, Power & UPS",
    category: "Networking",
    condition: "new",
    description:
      "Network cabinets, rack power distribution, smart UPS backup, and cabling ducts for clean installations.",
    image: image("lpo-rack-ups"),
    items: [
      {
        id: "rack-9u",
        name: "19\" 9U Rack Cabinet",
        price: 184,
        detail: "Cold-rolled steel, wall/floor mount, lockable doors",
      },
      {
        id: "pdu-1u",
        name: "1U Rack PDU - 5 Sockets",
        price: 34,
        detail: "19\" rack-mount, 220-240V AC, 10-16A",
      },
      {
        id: "apc-smt1500c",
        brand: "APC",
        name: "APC Smart-UPS 1500VA (SMT1500C)",
        price: 987,
        detail: "900W pure sine wave, LCD, AVR, SmartConnect",
      },
      {
        id: "hdpe-25mm",
        name: "HDPE Pipe 25mm - 100m Roll",
        price: 47,
        detail: "Cable ducting for outdoor and underground runs",
      },
    ],
  },
  {
    id: "barcode-scanners",
    name: "Barcode Scanners",
    category: "Peripherals & Office",
    condition: "new",
    description:
      "Wireless 2D barcode scanners for retail, warehouses, pharmacies, and inventory teams.",
    image: image("lpo-barcode-scanner"),
    items: [
      {
        id: "wireless-2d",
        name: "2.4G Wireless 2D Barcode Scanner",
        price: 99,
        detail: "Reads 1D/2D & QR codes, USB wireless receiver",
      },
    ],
  },
  {
    id: "secure-sdwan",
    name: "Secure SD-WAN & Next-Gen Firewalls",
    category: "Networking",
    condition: "new",
    description:
      "Fortinet FortiGate next-generation firewalls and VeloCloud SD-WAN edges, designed, installed and managed by Jero-One to securely connect your head office, branches and cloud apps.",
    image: image("lpo-sdwan-firewall"),
    quoteOnly: true,
    benefits: [
      "Block ransomware, malware and intrusions at the network edge with FortiGate NGFW and FortiGuard threat intelligence",
      "Link every branch over fibre, 4G/5G and broadband at once, with VeloCloud steering traffic around outages automatically",
      "Faster Microsoft 365, Zoom/Teams and cloud apps through application-aware routing",
      "One dashboard for every site: zero-touch deployment, central policy and real-time visibility",
    ],
    useCases: [
      { title: "Branch offices & retail chains", text: "Connect dozens of sites to head office with consistent security and no expensive MPLS lines." },
      { title: "Banks & SACCOs", text: "Segmented, encrypted links for core banking, ATMs and CCTV, with audit-ready logging." },
      { title: "Schools & universities", text: "Content filtering, student/staff Wi-Fi separation and bandwidth control for e-learning." },
      { title: "NGOs, hospitals & government", text: "Resilient connectivity for remote field offices with secure remote access for staff." },
    ],
    included: [
      "Hardware supply with genuine manufacturer warranty",
      "Licensing: FortiGuard UTP / VeloCloud subscription (1, 3 or 5 years)",
      "Site survey, network design and configuration",
      "Installation, testing and handover documentation",
      "Staff training and optional 24/7 managed monitoring & support",
    ],
    faqs: [
      { q: "Why is pricing on request?", a: "The total depends on the number of sites, bandwidth, licence tier and term. We size the right model and send a detailed quotation, usually within one business day." },
      { q: "Do I need both FortiGate and VeloCloud?", a: "Not always. A single office often needs only a FortiGate. Multi-branch organisations benefit from VeloCloud SD-WAN, often paired with FortiGate for advanced security." },
      { q: "Can you work with my existing internet providers?", a: "Yes. SD-WAN combines your existing fibre, broadband and 4G/5G links from any ISP into one resilient connection." },
      { q: "Do you offer managed services?", a: "Yes. We can monitor, patch and manage your firewalls and SD-WAN edges 24/7 from our NOC under a monthly service plan." },
    ],
    items: [
      { id: "fortigate-40f", brand: "Fortinet", quoteOnly: true, name: "Fortinet FortiGate 40F", detail: "Small office / branch NGFW, 5x GbE, SD-WAN built in" },
      { id: "fortigate-60f", brand: "Fortinet", quoteOnly: true, name: "Fortinet FortiGate 60F", detail: "Branch & SMB NGFW, 10x GbE, secure SD-WAN" },
      { id: "fortigate-100f", brand: "Fortinet", quoteOnly: true, name: "Fortinet FortiGate 100F", detail: "Mid-size enterprise NGFW, 10G SFP+, high-availability ready" },
      { id: "fortigate-200f", brand: "Fortinet", quoteOnly: true, name: "Fortinet FortiGate 200F", detail: "Campus / data-centre edge NGFW, high threat-protection throughput" },
      { id: "velocloud-edge-510", brand: "VeloCloud", quoteOnly: true, name: "VeloCloud SD-WAN Edge 510", detail: "Small branch, retail and kiosk sites" },
      { id: "velocloud-edge-610", brand: "VeloCloud", quoteOnly: true, name: "VeloCloud SD-WAN Edge 610", detail: "Branch office edge with multi-link failover" },
      { id: "velocloud-edge-640", brand: "VeloCloud", quoteOnly: true, name: "VeloCloud SD-WAN Edge 640", detail: "Medium-to-large branch, higher throughput" },
      { id: "velocloud-edge-680", brand: "VeloCloud", quoteOnly: true, name: "VeloCloud SD-WAN Edge 680", detail: "Large branch / regional hub edge" },
      { id: "sdwan-managed", quoteOnly: true, name: "Design, Licensing & Managed Service", detail: "FortiGuard / VeloCloud licences, setup and 24/7 monitoring" },
    ],
  },
  {
    id: "interactive-conferencing",
    name: "Interactive Boards & Conference Rooms",
    category: "Audio Visual & Conferencing",
    condition: "new",
    description:
      "Complete smart-board and video-conferencing room installations for boardrooms, e-learning and hybrid classrooms, supplied, installed and managed end-to-end by Jero-One.",
    image: image("lpo-conference-room"),
    benefits: [
      "One-touch Zoom Rooms / Microsoft Teams meetings with 4K interactive display and wireless sharing",
      "Crystal-clear audio and 12x optical-zoom video so remote participants feel in the room",
      "Interactive whiteboarding and touch-back for training, lectures and e-learning",
      "Clean, professional installation with concealed cabling and full user training",
    ],
    useCases: [
      { title: "Boardrooms & meeting rooms", text: "Hybrid meetings with remote offices and partners on Teams or Zoom." },
      { title: "E-learning & smart classrooms", text: "Interactive lessons, recorded lectures and remote students." },
      { title: "Training centres", text: "Hands-on workshops with wireless screen sharing from any laptop." },
      { title: "Government & NGO halls", text: "Larger rooms with installed speakers, mixer-amplifier and microphones." },
    ],
    included: [
      "75-inch 4K interactive display with collaboration apps",
      "Wireless presentation (Barco ClickShare) and room PC for Zoom Rooms / Teams",
      "Conferencing camera, touch console with 360° microphones and installed speakers",
      "Complete cabling, trunking and brackets",
      "Installation, programming, testing, commissioning, user training and handover",
    ],
    faqs: [
      { q: "Can I buy a complete room package?", a: "Yes. Add the items you need here, or request a quote for a full turnkey room including professional installation." },
      { q: "Does it work with Microsoft Teams and Zoom?", a: "Yes. The Intel NUC room host runs Zoom Rooms or Microsoft Teams Rooms, and ClickShare lets anyone share from their laptop." },
      { q: "Do you support the room after installation?", a: "Yes. We train your staff at handover and offer ongoing support and maintenance plans." },
    ],
    items: [
      { id: "benq-rm7504", brand: "BenQ", name: "BenQ RM7504 75\" 4K Interactive Display", price: 4829, detail: "4K UHD, multi-point IR touch, collaboration apps, Android + Windows OPS" },
      { id: "barco-cx30", brand: "Barco", name: "Barco ClickShare CX-30 Gen2", price: 5046, detail: "Wireless 4K sharing, dual-screen layouts, touch-back support" },
      { id: "intel-nuc14-pro", brand: "Intel", name: "Intel NUC 14 Pro Room PC", price: 1447, detail: "Core i7-class, 16GB RAM, 1TB SSD; hosts Zoom Rooms / MS Teams" },
      { id: "yealink-uvc84", brand: "Yealink", name: "Yealink UVC84 Conference Camera", price: 1848, detail: "1080p, wide-angle lens, 12x motorized optical zoom" },
      { id: "yealink-cp965", brand: "Yealink", name: "Yealink CP965 Conference Console", price: 1223, detail: "Colour touch panel, 360° mic array, noise cancelling" },
      { id: "jbl-control-25-1", brand: "JBL", name: "JBL Control 25-1 Installation Speaker (each)", price: 456, detail: "Two-way background/foreground speaker with mounting kit" },
      { id: "bosch-ple-1me060", brand: "Bosch", name: "Bosch PLE-1ME060-EU Mixer Amplifier", price: 680, detail: "80W all-in-one amplifier + multi-channel mixer" },
      { id: "av-cabling-bundle", name: "Complete AV Cabling Bundle (lot)", price: 388, detail: "Conduit trunking, 4K HDMI 2.0, balanced mic/speaker wiring, brackets" },
      { id: "av-installation", quoteOnly: true, name: "Professional Installation & Commissioning", detail: "Installation, configuration, programming, testing, training and handover" },
    ],
  },
]

PRODUCTS.push(...EXTRA_LINES)

// Temporary hidden line for a live $1 payment test (private link only).
export const ALL_PRODUCTS = [...PRODUCTS, {
  id: "live-payment-test-7k3q",
  name: "Live Payment Test",
  category: "Software & Licensing",
  condition: "new",
  image: "/website-assets/images/lpo-barcode-scanner-1000x760.jpg",
  description: "Private $1 item used only to verify live payments, receipts and delivery emails. Not for sale.",
  items: [{ id: "test-1usd", name: "Live Payment Test ($1)", price: 1, detail: "Choose Store Pickup at checkout" }],
}]

export const MANUFACTURERS = [
  "HP",
  "HPE",
  "Dell",
  "Lenovo",
  "Apple",
  "Acer",
  "Asus",
  "Cisco",
  "Arista",
  "MikroTik",
  "Ubiquiti",
  "ZKTeco",
  "Hikvision",
  "Dahua",
  "APC",
  "Fortinet",
  "VeloCloud",
  "Sophos",
]
